export const chromeLink = 'https://www.google.com/chrome/';
export const firefoxLink = 'https://www.mozilla.org/en-US/firefox/new/';
export const edgeLink =
  'https://www.microsoft.com/en-us/windows/microsoft-edge';
